import { render, staticRenderFns } from "./SiblingNavigation.vue?vue&type=template&id=062f2fca"
import script from "./SiblingNavigation.vue?vue&type=script&lang=js"
export * from "./SiblingNavigation.vue?vue&type=script&lang=js"
import style0 from "./SiblingNavigation.vue?vue&type=style&index=0&id=062f2fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports